'use strict';

function AnchoredCTA() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_ResponsiveLayout, _ScrollingLayout];
  this.content = null;

  this.class = {
    hidden_class: 'anchored-cta--hidden'
  };

  this.init = function () {};

  this.initAllReady = function () {
    this.$node = $(this.node);

    var mobile = mogo.registry.mogoUI.config.mediaQueries.small;
    this.registerResponsiveFunction(this._scrollVisibilityToggle, null, mobile);
    this.registerResponsiveFunction(this._removeDisplayProperty, mobile + 1, null);

    // This reruns the function after items are lazyloaded to ensure that the offset distances from the top are correct
    $('.lazyload').load($.proxy(function () {
      this.registerResponsiveFunction(this._scrollVisibilityToggle, null, mobile);
      this.registerResponsiveFunction(this._removeDisplayProperty, mobile + 1, null);
    }, this));
  };

  this._scrollVisibilityToggle = function () {
    this._$window = $(window);
    this._anchoredCTAVisible = true;

    // This finds the top of the footer, since the footer doesn't load on page load
    this._$lastSection = $('.yield > div:last-of-type');
    this._footerTop = this._$lastSection.offset().top + this._$lastSection.height() - this._$window.height() / 2;

    // This matches the transition time in _anchored-cta.scss so that the user can't click the button when it isn't visible
    this._transitionDuration = 500;

    var _this = this;

    this._$window.on('scroll', Throttle(function (event) {
      _this._scrollingFunction();
    }));
  };

  this._scrollingFunction = function () {
    if ($(window).scrollTop() >= this._footerTop && this._anchoredCTAVisible === true) {
      this.$node.addClass(this.class.hidden_class);
      setTimeout($.proxy(function () {
        this.$node.hide();
        this._anchoredCTAVisible = false;
      }, this), this._transitionDuration);
    } else if ($(window).scrollTop() < this._footerTop && this._anchoredCTAVisible === false) {
      this._removeDisplayProperty();
      setTimeout($.proxy(function () {
        this.$node.removeClass(this.class.hidden_class);
        this._anchoredCTAVisible = true;
      }, this), this._transitionDuration);
    }
  };

  this._removeDisplayProperty = function () {
    this.$node.css('display', '');
  };
}